module.exports = __webpack_public_path__ + "static/media/pill.95ef73b6.svg";